import React, { forwardRef } from 'react';
import { FormField, HelperText, Label, StyledSelect } from './styles';

type SelectProps = Omit<JSX.IntrinsicElements['select'], 'name'> & {
  name: string;
  error?: boolean;
  label?: string;
  helperText?: React.ReactNode | string;
  value?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode | React.ReactNode[];
};

const Select = forwardRef<HTMLSelectElement, SelectProps>((props: SelectProps, ref) => {
  const { error, label, helperText, name, value, onChange, children, ...rest } = props;

  return (
    <FormField>
      {label ? <Label htmlFor={name}>{label}</Label> : null}

      <StyledSelect {...rest} error={error ?? false} name={name} value={value} onChange={onChange} ref={ref}>
        {children}
      </StyledSelect>

      {helperText ? <HelperText error={error ?? false}>{helperText}</HelperText> : null}
    </FormField>
  );
});

Select.displayName = 'Select';

export default Select;
